import { Controller } from "@hotwired/stimulus"
import { put } from "@rails/request.js";

export default class extends Controller {
  static targets = ["input", "span", "placeholder", "editBtn", "updateBtn"];
  static values = {
    text: String,
    url: String,
    controller: String,
    field: String,
  }

  connect() {
    this.spanTarget.textContent = this.inputTarget.value || " ";
    this.inputTarget.style.width = Math.max(this.spanTarget.offsetWidth + 10, 50) + "px";
  }

  startEditing() {
    this.spanTarget.textContent = this.inputTarget.value || " ";
    this.inputTarget.style.width = Math.max(this.spanTarget.offsetWidth + 10, 50) + "px";

    this.placeholderTarget.classList.add("hidden");
    this.inputTarget.classList.remove("hidden");
    this.editBtnTarget.classList.add("hidden");
    this.updateBtnTarget.classList.remove("hidden");
    this.inputTarget.focus();

    // Add event listener for dynamic width updates
    this.inputTarget.addEventListener('input', this.updateWidth.bind(this));

    const length = this.inputTarget.value.length + 1;
    // this.inputTarget.setSelectionRange(length, length);
  }

  updateTitle() {
    const title = this.inputTarget.value.trim();

    // Check if title is empty and show toaster message
    if (!title) {
      const toaster = document.createElement('div');
      toaster.textContent = 'Не может быть пустым';
      toaster.className = 'alert alert-danger position-fixed shadow';
      toaster.style.cssText = 'top:20px;right:20px;z-index:1000;opacity:0;transition:opacity 0.3s ease;';
      document.body.appendChild(toaster);
      setTimeout(() => toaster.style.opacity = '1', 10);
      setTimeout(() => { toaster.style.opacity = '0'; setTimeout(() => toaster.remove(), 300); }, 3000);
      return;
    }

    put(this.urlValue, {
      responseKind: "turbo-stream",
      body: {
        [this.controllerValue]: {
          [this.fieldValue]: title,
        }
      }
    }).then(response => {
      console.log('Response received:', response.ok)

      if (response.ok) {
        this.placeholderTarget.textContent = title;
      }

      this.placeholderTarget.classList.remove("hidden");
      this.inputTarget.classList.add("hidden");
      this.editBtnTarget.classList.remove("hidden");
      this.updateBtnTarget.classList.add("hidden");
    });
  }

  updateWidth(e) {
    const value = e.target ? e.target.value : this.inputTarget.value;
    this.spanTarget.textContent = value || " ";
    this.inputTarget.style.width = Math.max(this.spanTarget.offsetWidth + 10, 50) + "px";
  }

  showHint(event) {
    event.stopPropagation();
    const toaster = document.createElement('div');
    toaster.textContent = event.target.closest('[data-hint-text]').dataset.hintText;
    toaster.className = 'alert alert-danger position-fixed shadow';
    toaster.style.cssText = 'top:20px;right:20px;z-index:1000;opacity:0;transition:opacity 0.3s ease;';
    document.body.appendChild(toaster);
    setTimeout(() => toaster.style.opacity = '1', 10);
    setTimeout(() => { toaster.style.opacity = '0'; setTimeout(() => toaster.remove(), 300); }, 3000);
  }
}
